import PropTypes from 'prop-types';
import V360Thumbnail from './V360Thumbnail';
import css from './V360Thumbnail.scss';

V360Thumbnail.displayName = 'V360Thumbnail';

const classes = {
	thumbnail: css.v360Thumbnail,
	thumbnailLink: css.v360ThumbnailLink,
	thumbnailBox: css.v360ThumbnailBox,
	thumbnailFigure: css.v360ThumbnailFigure,
	thumbnailImage: css.v360ThumbnailImage,
	thumbnailCaption: css.v360ThumbnailCaption,
	isActive: css.isActive,
};

V360Thumbnail.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	active: PropTypes.bool,
	data: PropTypes.object,
};

V360Thumbnail.defaultProps = {
	className: '',
	classes,
	active: false,
};

export { V360Thumbnail };
export default V360Thumbnail;
